export function arrayWithoutElement(array, toRemove) {
  return array.toSpliced(
    array.findIndex((i) => i === toRemove),
    1
  )
}
